import { Schema } from 'yup';
import * as yup from 'yup';
import { TFunction } from 'react-i18next';
import { AssociationFeeRequest } from '../models/associationFeeRequest';

export function AssociationFeeRequestSchema(t: TFunction): Schema<AssociationFeeRequest> {
  return yup.object().shape({
    localAss_id: yup.number().required(),
    paymentMethod: yup.number().required(),
    ocr: yup.string().oneOf(['true', 'false']).required(),
    feeFriend: yup
      .number()
      .optional()
      .integer(t('association:distributedFeeWholeNumbers') as string)
      .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
    feeFriendAutogiro: yup
      .number()
      .optional()
      .integer(t('association:distributedFeeWholeNumbers') as string)
      .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
    feeFriendSwish: yup
      .number()
      .optional()
      .integer(t('association:distributedFeeWholeNumbers') as string)
      .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
    // Aviseringsmetod
    sameFeeForAll: yup.number().optional(),
    sameFeeForAllAutogiro: yup
      .number()
      .optional()
      .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
    sameFeeForAllSwish: yup
      .number()
      .optional()
      .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
    mainAndFamily: yup
      .object({
        feeMainMember: yup.number().optional(),
        feeMainMemberAutogiro: yup
          .number()
          .optional()
          .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
        feeFamilyMember: yup.number().optional(),
        feeFamilyMemberAutogiro: yup
          .number()
          .optional()
          .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
        feeMainMemberSwish: yup
          .number()
          .optional()
          .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
        feeFamilyMemberSwish: yup
          .number()
          .optional()
          .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
      })
      .optional(),
    familySteps: yup
      .array()
      .of(
        yup.object().shape({
          member: yup.string().optional(),
          fee: yup.number().optional(),
          feeAutogiro: yup
            .number()
            .optional()
            .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
          feeSwish: yup
            .number()
            .optional()
            .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
        }),
      )
      .optional(),

    oneFeeForHousehold: yup.number().optional(),
    oneFeeForHouseholdAutogiro: yup
      .number()
      .optional()
      .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
    oneFeeForHouseholdSwish: yup
      .number()
      .optional()
      .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
    // Profiler
    feeBasedOnProfile: yup
      .array()
      .of(
        yup.object().shape({
          memberProfileItem_id: yup.number().required(),
          profileGroup: yup.string().required(),
          profile: yup.string().required(),
          fee: yup.number().required(t('association:paymentMethod.feeRequired')),
          feeAutogiro: yup
            .number()
            .optional()
            .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
          feeSwish: yup
            .number()
            .optional()
            .transform((value, originalValue) => (originalValue === '' || originalValue === null ? undefined : value)),
        }),
      )
      .optional()
      .nullable(),
  });
}
